<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">TBK Claim</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>TBK</b> / <b>Claims</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- New -->
        <div></div>
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">
              New
              <span
                class="badge badge-pill badge-danger"
                v-if="new_claims.length !== 0"
                >{{ new_claims.length }}</span
              >
            </h4>
            <p>The table below shows the list of new claims.</p>
            <div class="table-responsive">
              <table
                id="new_claim_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Customer Name</th>
                    <th>Product</th>
                    <th>Type</th>
                    <th>Notification Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(claim, index) in new_claims" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <router-link :to="customerPage(claim.customer_ic)">
                        {{ claim.customer_name }}
                      </router-link>
                    </td>
                    <td>
                      <router-link :to="productPage(claim.product_id)">
                        {{ claim.product_name }}
                      </router-link>
                    </td>
                    <td>{{ claim.type }}</td>
                    <td>
                      {{
                        claim.notification_date
                          | moment("Do MMMM YYYY, h:mm:ss a")
                      }}
                    </td>
                    <td>
                      <router-link
                        :to="claimDetail(claim.claim_id)"
                        type="button"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color: #78BE20; border-color: #78BE20;"
                        >View Details</router-link
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <br />

        <!-- In Process -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">In Process</h4>
            <p>The table below shows the list of in process claims.</p>
            <div class="table-responsive">
              <table
                id="inprocess_claim_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Customer Name</th>
                    <th>Product</th>
                    <th>Type</th>
                    <th>Date submit to counter</th>
                    <th>Notification Date</th>
                    <th>Deadline Date</th>
                    <th>Officer</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(claim, index) in inprocess_claims" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <router-link :to="customerPage(claim.customer_ic)">
                        {{ claim.customer_name }}
                      </router-link>
                    </td>
                    <td>
                      <router-link :to="productPage(claim.product_id)">
                        {{ claim.product_name }}
                      </router-link>
                    </td>
                    <td>{{ claim.type }}</td>
                    <td>
                      {{
                        claim.counter_date | moment("Do MMMM YYYY, h:mm:ss a")
                      }}
                    </td>
                    <td>
                      {{
                        claim.notification_date
                          | moment("Do MMMM YYYY, h:mm:ss a")
                      }}
                    </td>
                    <td>{{ claim.deadline_date | moment("Do MMMM YYYY") }}</td>
                    <td>{{ claim.officer_name }}</td>
                    <td>
                      <router-link
                        :to="claimDetail(claim.claim_id)"
                        type="button"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color: #78BE20; border-color: #78BE20;"
                        >View Details</router-link
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <br />

        <!-- Completed -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Completed</h4>
            <p>The table below shows the list of completed claims.</p>
            <div class="table-responsive">
              <table
                id="completed_claim_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Customer Name</th>
                    <th>Product</th>
                    <th>Type</th>
                    <th>Notification Date</th>
                    <th>Deadline Date</th>
                    <th>Officer</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(claim, index) in completed_claims" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <router-link :to="customerPage(claim.customer_ic)">
                        {{ claim.customer_name }}
                      </router-link>
                    </td>
                    <td>
                      <router-link :to="productPage(claim.product_id)">
                        {{ claim.product_name }}
                      </router-link>
                    </td>
                    <td>{{ claim.type }}</td>
                    <td>
                      {{
                        claim.notification_date
                          | moment("Do MMMM YYYY, h:mm:ss a")
                      }}
                    </td>
                    <td>{{ claim.deadline_date | moment("Do MMMM YYYY") }}</td>
                    <td>{{ claim.officer_name }}</td>
                    <td>Completed</td>
                    <td>
                      <router-link
                        :to="claimDetail(claim.claim_id)"
                        type="button"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color: #78BE20; border-color: #78BE20;"
                        >View Details</router-link
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <br />

        <!-- Rejected -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Rejected</h4>
            <p>The table below shows the list of rejected claims.</p>
            <div class="table-responsive">
              <table
                id="rejected_claim_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Customer Name</th>
                    <!-- <th>Certificate No</th> -->
                    <th>Product</th>
                    <th>Type</th>
                    <th>Notification Date</th>
                    <th>Deadline Date</th>
                    <th>Officer</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(claim, index) in rejected_claims" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <router-link :to="customerPage(claim.customer_ic)">
                        {{ claim.customer_name }}
                      </router-link>
                    </td>
                    <!-- <td>
                    <router-link :to = "purchaseDetail(claim.detail_id)">
                      {{claim.cert_no}}
                    </router-link>
                  </td> -->
                    <td>{{ claim.product_name }}</td>
                    <td>{{ claim.type }}</td>
                    <td>
                      {{
                        claim.notification_date
                          | moment("Do MMMM YYYY, h:mm:ss a")
                      }}
                    </td>
                    <td>{{ claim.deadline_date | moment("Do MMMM YYYY") }}</td>
                    <td>{{ claim.officer_name }}</td>
                    <td>Rejected</td>
                    <td>
                      <router-link
                        :to="claimDetail(claim.claim_id)"
                        type="button"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color: #78BE20; border-color: #78BE20;"
                        >View Details</router-link
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "tbk_claim",
  components: {},
  data() {
    return {
      new_claims: [],
      inprocess_claims: [],
      completed_claims: [],
      rejected_claims: []
    };
  },

  methods: {
    loadClaims() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/tbk/claim", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.new_claims = res.data.new;
            this.inprocess_claims = res.data.inprocess;
            this.completed_claims = res.data.completed;
            this.rejected_claims = res.data.rejected;
            this.destroyDatatable();
          })
          .then(function() {
            $("#new_claim_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: [
                {
                  extend: "excelHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4]
                  }
                },
                {
                  extend: "pdfHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4]
                  }
                }
              ]
            });
            $("#inprocess_claim_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: [
                {
                  extend: "excelHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4, 5, 6, 7]
                  }
                },
                {
                  extend: "pdfHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4, 5, 6, 7]
                  }
                }
              ]
            });
            $("#completed_claim_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: [
                {
                  extend: "excelHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4, 5, 6, 7]
                  }
                },
                {
                  extend: "pdfHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4, 5, 6, 7]
                  }
                }
              ]
            });
            $("#rejected_claim_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: [
                {
                  extend: "excelHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4, 5, 6, 7]
                  }
                },
                {
                  extend: "pdfHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4, 5, 6, 7]
                  }
                }
              ]
            });
          });
      }
    },

    destroyDatatable() {
      $("#inprocess_claim_tbl")
        .DataTable()
        .destroy();
      $("#new_claim_tbl")
        .DataTable()
        .destroy();
      $("#completed_claim_tbl")
        .DataTable()
        .destroy();
      $("#rejected_claim_tbl")
        .DataTable()
        .destroy();
    },

    loadAllData() {
      this.loadClaims();

      // setTimeout(function() {

      //   $('#new_claim_tbl').DataTable({
      //     "pageLength": 5,
      //     dom: 'Bfrtip',
      //     buttons: [
      //       'excel', 'pdf'
      //     ]
      //   });
      //   $('#inprocess_claim_tbl').DataTable({
      //     "pageLength": 5,
      //     dom: 'Bfrtip',
      //     buttons: [
      //       'excel', 'pdf'
      //     ]
      //   });
      //   $('#completed_claim_tbl').DataTable({
      //     "pageLength": 5,
      //     dom: 'Bfrtip',
      //     buttons: [
      //       'excel', 'pdf'
      //     ]
      //   });
      //   $('#rejected_claim_tbl').DataTable({
      //     "pageLength": 5,
      //     dom: 'Bfrtip',
      //     buttons: [
      //       'excel', 'pdf'
      //     ]
      //   });

      // }, 1500);

      // setTimeout(function() { $('#new_claim_tbl').DataTable(); }, 1000);
      // setTimeout(function() { $('#inprocess_claim_tbl').DataTable(); }, 1000);
      // setTimeout(function() { $('#completed_claim_tbl').DataTable(); }, 1000);
      // setTimeout(function() { $('#rejected_claim_tbl').DataTable(); }, 1000);
    },

    claimDetail(id) {
      return "/tbk/claim_details/" + id;
    },

    purchaseDetail(id) {
      return "/tbk/details/" + id;
    },

    customerPage(customer_ic) {
      return "/customer/" + customer_ic;
    },

    productPage(id) {
      return "/marketing/product/detail/" + id;
    }
  },

  mounted() {
    this.loadAllData();
  }
};
</script>
